export default "__VITE_ASSET__Csq$XpWY__"